import isUndefined from 'lodash/isUndefined';

const replacerFn = (key, value) => (isUndefined(value) ? null : value);

const stringify = content => JSON.stringify(content, replacerFn);

export default stringify;
